import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, reactive } from "vue";
import { ViewIndex } from "@/classes/data-structures/view-index";
import Layers from "@/components/Viewer/Layers.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersMenu',
  props: {
	viewIndex: {
		type: String as PropType<ViewIndex>,
		required: true,
		default: ViewIndex.View1
	}
},
  setup(__props) {

const props = __props;



const data = reactive({
	visible: false
});

function toggleLayers() {
	data.visible = !data.visible;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layers-menu", { 'visible': data.visible, 'right': props.viewIndex == _unref(ViewIndex).View2 }])
  }, [
    _createVNode(Layers, {
      class: "layers-panel w-100 h-100",
      viewIndex: props.viewIndex,
      enableEditing: false
    }, null, 8, ["viewIndex"]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleLayers())),
      class: "layers-menu-button"
    })
  ], 2))
}
}

})